
export enum Page {
  HOME = 'home',
  SHOP = 'shop',
  BLOG = 'blog',
  ABOUT = 'about',
  CONTACT = 'contact',
  SHIPPING_POLICY = 'shipping_policy',
  RETURN_POLICY = 'return_policy',
  PRODUCT_DETAIL = 'product_detail',
  BLOG_POST = 'blog_post',
  ADMIN_LOGIN = 'admin_login',
  ADMIN_DASHBOARD = 'admin_dashboard',
  DMCA = 'dmca'
}

export type Language = 'vi' | 'en';

export type UserRole = 'owner' | 'admin' | 'staff' | 'none';

export type OrderStatus = 'new' | 'pending' | 'processing' | 'completed' | 'cancelled';

export interface Product {
  id: number;
  name: string;
  nameEn: string;
  price: string;
  priceValue: number;
  description: string;
  descriptionEn: string;
  image: string;
  tag?: string;
  tagEn?: string;
  tagColor?: 'primary' | 'earth' | 'blue';
  category: string;
  categoryEn: string;
  is_featured?: boolean;
  stock_quantity?: number;
}

export interface Article {
  id: number;
  title: string;
  titleEn: string;
  excerpt: string;
  excerptEn: string;
  category: string;
  categoryEn: string;
  animalType?: string;
  animalTypeEn?: string;
  readTime: string;
  readTimeEn: string;
  image: string;
  content?: string;
  contentEn?: string;
}

export interface SocialLink {
  platform: string;
  url: string;
  icon: string;
  color: string;
}

export interface SiteSettings {
  hero: {
    tag: string; tag_en: string;
    title: string; title_en: string;
    desc: string; desc_en: string;
    image: string;
    cta: string; cta_en: string;
  };
  features: Array<{
    icon: string;
    title: string; title_en: string;
    desc: string; desc_en: string;
  }>;
  contact_preview: {
    title: string; title_en: string;
    desc: string; desc_en: string;
    hotline: string;
    email: string;
  };
  support_channels?: {
    zalo_phone: string;     // Số điện thoại Zalo
    messenger_id: string;   // ID/Username Fanpage
    working_hours: string;  // Giờ mở cửa
    telegram_chat_id?: string; // ID chat Telegram
  };
  social_links?: SocialLink[];
  branding?: {
    logo_url: string;
    favicon_url: string;
  };
  policies?: {
    shipping: { vi: string; en: string };
    return: { vi: string; en: string };
  };
}

// Admin-related types
export interface AdminUser {
  id: number;
  email: string;
  role: UserRole;
  created_at: string;
}

export interface ContactSubmission {
  id: string;
  name: string;
  phone: string;
  email: string;
  subject: string;
  message: string;
  status: OrderStatus;
  created_at: string;
}

export interface SettingItem {
  key: string;
  value: unknown;
}

export interface TempSettings {
  heroTitle: string;
  heroDesc: string;
  heroImage: string;
  heroTag: string;
  contactHotline: string;
  contactEmail: string;
  zaloPhone: string;
  messengerId: string;
  workingHours: string;
  telegramChatId: string;
  facebookUrl: string;
  instagramUrl: string;
  logoUrl: string;
  faviconUrl: string;
  shippingVi: string;
  shippingEn: string;
  returnVi: string;
  returnEn: string;
}

// User type from Supabase Auth
export interface AuthUser {
  id: string;
  email?: string;
  user_metadata?: Record<string, unknown>;
}

